const getTHeadRows = () => ([
  {
    value: 'Item changed',
    align: 'left',
    className: 'whitespace-nowrap',
  },
  {
    value: 'Changed from',
    align: 'right',
    className: 'whitespace-nowrap',
  },
  {
    value: 'Changed to',
    align: 'right',
    className: 'whitespace-nowrap',
  },
  {
    value: 'Changed by',
    align: 'left',
    className: 'whitespace-nowrap',
  },
  {
    value: 'Changing date',
    align: 'right',
    className: 'whitespace-nowrap',
  },
]);

export default getTHeadRows;
